import script from "./CardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CardItem.vue?vue&type=script&setup=true&lang=js"

import "./CardItem.vue?vue&type=style&index=0&id=781eb5a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-781eb5a6"]])

export default __exports__